import { buttonClasses, SxProps } from '@mui/material'

interface CurrencyAndLocationModalStyles {
  container: SxProps
  list: SxProps
  currencyButton: {
    root: SxProps
    active: SxProps
    text: SxProps
    icon: SxProps
  }
  actions: {
    wrapper: SxProps
    cancelButton: SxProps
    confirmButton: SxProps
  }
}

export const currencyAndLocationModalStyles: CurrencyAndLocationModalStyles = {
  container: {
    width: {
      md: 400,
      xs: '100%',
    },
    mb: { xs: 4 },
  },
  list: {
    maxHeight: { md: 450 },
    overflowY: { md: 'auto' },
  },
  currencyButton: {
    root: {
      display: 'flex',
      border: '1px solid',
      borderColor: 'utils.gray300',
    },
    active: {
      [`&.${buttonClasses.colorSecondary}`]: {
        borderColor: 'background.dark',
      },
    },
    text: {
      typography: 'textMdSemibold',
    },
    icon: {
      width: 18,
    },
  },
  actions: {
    wrapper: {
      gap: 1.5,
      flexDirection: { xs: 'column-reverse', md: 'row-reverse' },
    },
    cancelButton: {
      minWidth: 'auto',
      py: 1,
      border: '1px solid',
      borderColor: 'utils.gray300',
    },
    confirmButton: {
      minWidth: 'auto',
      py: 1,
      boxShadow: 'none',
    },
  },
}
